import {useEffect, useState} from 'react';
import {AvField, AvForm} from "availity-reactstrap-validation";
import OTPInput from "react-otp-input";
import {Button, Col, Label, Row} from "reactstrap";
import {FormattedMessage} from "react-intl";
import {MdOutlineRefresh} from "react-icons/md";
import {AiOutlineClockCircle} from "react-icons/ai";
import {RiLockPasswordLine} from "react-icons/ri";
import {urls} from "@api/urls";
import {GetRequest, PostRequest} from "@configs/request";
import patterns from "@constants/patterns";
import LoginStatus from "@utils/types/LoginStatus";
import SubmitButton from "@components/buttons/submitButton";
import Notify from "@components/noty/notify";

let interval;
let startSeconds = 120;
const otpLength = 5;
const intervalLength = 1000;

const VerifyForm = (
    {
        loginValue,
        otp,
        setOtp,
        setVerifyToken,
        registerInfo,
        handleRegisterInfoChange,
        isLoading,
        registerStatus,
        handleStep,
        handleVerify
    }
) => {
    //const timeLeft = useCountDownTimer(startSeconds);
    const [countDownSeconds, setCountDownSeconds] = useState(startSeconds);
    const [isUserNew, setIsUserNew] = useState(false);
    const [isLoadingOtp, setIsLoadingOtp] = useState(false);
    const [isOtpRequested, setIsOtpRequested] = useState(false);

    const [isLoadingLocation, setIsLoadingLocation] = useState(false);
    const [generalLocation, setGeneralLocation] = useState({});
    const [isSelectedProvinceInvalid, setIsSelectedProvinceInvalid] = useState(false);
    const [isSelectedCityInvalid, setIsSelectedCityInvalid] = useState(false);

    useEffect(() => {
        const isNotRegistered = parseInt(registerStatus) === LoginStatus.NotRegistered;
        setIsUserNew(isNotRegistered);

        if (!isNotRegistered && !isOtpRequested && countDownSeconds) {//old and not requested for otp yet
            handleTimer();
            setIsOtpRequested(true);
        }
    }, [registerStatus]);

    useEffect(() => {
        if (countDownSeconds === 0)
            clearInterval(interval);
    }, [countDownSeconds]);

    useEffect(() => {
        if (otp.length === otpLength)
            handleVerify();
    }, [otp]);

    const handleTimer = () => {
        if (!interval) {
            startCountDown();
            return;
        }
        setCountDownSeconds(startSeconds);
        clearInterval(interval);
        startCountDown();
    }

    const startCountDown = () => {
        interval = setInterval(() => {
            setCountDownSeconds(countDownSeconds => countDownSeconds - 1);
        }, intervalLength);
    }

    const secondsToHms = (d) => {
        d = Number(d);
        let m = Math.floor(d % 3600 / 60);
        let s = Math.floor(d % 3600 % 60);

        let mDisplay = m > 0 && m >= 10 ? m + ":" : "0" + m + ":";
        let sDisplay = s > 0 && s >= 10 ? s : "0" + s;
        return mDisplay + sDisplay;
    }

    const resetOtp = () => {
        setOtp("");
    }

    const editLoginValue = () => {
        resetOtp();
        handleStep(1);
    }

    useEffect(() => {
        if (isUserNew) {
            requestOtp()
        }
    }, [isUserNew])

    const requestOtp = () => {
        /*   if (isUserNew) {
               if (!registerInfo.firstName || !registerInfo.lastName) {
                   Notify('error', 'top-left', "ابتدا نام و نام خانوادگی را وارد نمایید.");
                   return;
               }
               /!*      if (!registerInfo.address) {
                         Notify('error', 'top-left', "ابتدا آدرس را وارد نمایید.");
                         return;
                     }
                     if (!registerInfo.province) {
                         setIsSelectedProvinceInvalid(true);
                         return;
                     }
                     if (!registerInfo.city) {
                         setIsSelectedCityInvalid(true);
                         return;
                     }*!/
           }*/

        if (otp)
            resetOtp();

        setIsLoadingOtp(true);

        const data = {
            'login': loginValue,
        }

        PostRequest(urls.web.login.requestOtp, data).then((response) => {
                if (response) {
                    const {ok, data} = response;

                    if (ok && data) {
                        setVerifyToken(data.verify_token);
                        setIsOtpRequested(true);
                        handleTimer();
                        Notify('success', 'top-left', `کد تایید به ${loginValue} ${data.otp_type}${isOtpRequested ? " مجددا" : ""} شد. `);
                    }
                }
            }
        ).finally(() => {
            setIsLoadingOtp(false);
        })
    }

    /*const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleVerify();
        }
    }*/

    return (
        <AvForm onValidSubmit={handleVerify} className="login-modal-verify-form">
            <div className="d-flex justify-content-between mb-1">
                <div>
                    <span>
                        <FormattedMessage id="LoginInfo"/>:
                    </span>
                    <span>{` ${loginValue} `}</span>
                </div>
                <Button
                    aria-label={"ویرایش"}
                    color="secondary"
                    className="login-modal-verify-form-back"
                    onClick={() => editLoginValue()}
                >
                    <small className="d-flex">ویرایش</small>
                </Button>
            </div>

            {isUserNew &&
                <Row>
                    <Col sm={12} md={12}>
                        <Label for="firstName">
                            <FormattedMessage id="firstName"/>
                            <i className="fa fa-star-of-life"/>
                        </Label>
                        <AvField
                            name="firstName"
                            id="firstName"
                            type='text'
                            value={registerInfo.firstName}
                            onChange={handleRegisterInfoChange}
                            validate={{
                                required: {value: true, errorMessage: 'الزامی می باشد.'},
                                pattern: patterns.persianLetters,
                                minLength: {
                                    value: 2,
                                    errorMessage: 'حروف وارد شده کمتر از تعداد مجاز است.'
                                },
                                maxLength: {
                                    value: 35,
                                    errorMessage: 'حروف وارد شده بیشتر از تعداد مجاز است.'
                                }
                            }}
                        />
                    </Col>

                    <Col sm={12} md={12}>
                        <Label for="lastName">
                            <FormattedMessage id="lastName"/>
                            <i className="fa fa-star-of-life"/>
                        </Label>
                        <AvField
                            name="lastName"
                            id="lastName"
                            type='text'
                            value={registerInfo.lastName}
                            onChange={handleRegisterInfoChange}
                            validate={{
                                required: {value: true, errorMessage: 'الزامی می باشد.'},
                                pattern: patterns.persianLetters,
                                minLength: {
                                    value: 2,
                                    errorMessage: 'حروف وارد شده کمتر از تعداد مجاز است.'
                                },
                                maxLength: {
                                    value: 35,
                                    errorMessage: 'حروف وارد شده بیشتر از تعداد مجاز است.'
                                }
                            }}
                        />
                    </Col>

                    {/*  <Col sm={12} md={12}>
                        <Label for="national_code" className='font-weight-bolder'>
                            <FormattedMessage id="nationalCode"/>
                        </Label>
                        <AvField
                            name="national_code"
                            id="national_code"
                            type='text'
                            value={registerInfo?.national_code}
                            onChange={handleRegisterInfoChange}
                            validate={{
                                pattern: patterns.number('لطفا کد ملی را به درستی وارد نمایید'),
                                minLength: {value: 10, errorMessage: "کد ملی 10 رقم دارد."},
                                maxLength: {value: 10, errorMessage: "کد ملی 10 رقم دارد."}
                            }}
                        />
                    </Col>*/}

                    {/*       <Col sm={12} md={6}>
                        <Label for="province" className='font-weight-bolder'>
                            <FormattedMessage id="Province"/>
                            <i className="fa fa-star-of-life"/>
                        </Label>
                        <AvGroup>
                            <Select
                                theme={selectThemeColors}
                                className={`react-select${isSelectedProvinceInvalid && !registerInfo?.province ? ' empty-select' : ''}`}
                                classNamePrefix='select'
                                id="province"
                                value={registerInfo?.province}
                                options={generalLocation}
                                isSearchable
                                onChange={(value) => handleRegisterInfoChange(null, {
                                    name: "province",
                                    value: value
                                })}
                                placeholder='انتخاب...'
                                noOptionsMessage={
                                    () => isLoadingLocation ?
                                        <Spinner/> : "موردی وجود ندارد"
                                }
                            />
                            {isSelectedProvinceInvalid && !registerInfo?.province &&
                                <span className='invalid-feedback'>الزامی می باشد.</span>}
                        </AvGroup>
                    </Col>

                    <Col sm={12} md={6}>
                        <Label for="city" className='font-weight-bolder'>
                            <FormattedMessage id="City"/>
                            <i className="fa fa-star-of-life"/>
                        </Label>
                        <AvGroup>
                            <Select
                                theme={selectThemeColors}
                                className={`react-select${isSelectedCityInvalid && !registerInfo?.city ? ' empty-select' : ''}`}
                                classNamePrefix='select'
                                id="city"
                                value={registerInfo?.city}
                                options={registerInfo?.province?.cities}
                                isSearchable
                                onChange={(value) => handleRegisterInfoChange(null, {
                                    name: "city",
                                    value: value
                                })}
                                placeholder='انتخاب...'
                                noOptionsMessage={
                                    () => isLoadingLocation ?
                                        <Spinner/> : registerInfo?.province ? "موردی وجود ندارد" : "استان را انتخاب کنید."
                                }
                            />
                            {isSelectedCityInvalid && !registerInfo?.city &&
                                <span className='invalid-feedback'>الزامی می باشد.</span>}
                        </AvGroup>
                    </Col>

                    <Col sm={12} md={12}>
                        <Label for="address" className='font-weight-bolder'>
                            <FormattedMessage id="Addresses"/>
                            <i className="fa fa-star-of-life"/>
                        </Label>
                        <AvField
                            name="address"
                            id="address"
                            type='textarea'
                            rows={4}
                            value={registerInfo?.address}
                            onChange={handleRegisterInfoChange}
                            validate={{
                                required: {value: true, errorMessage: "الزامی می باشد."}
                            }}
                        />
                    </Col>*/}
                </Row>
            }

            <div className="mb-1 position-relative">
                <Label for="firstName">
                    کد تایید
                    <i className="fa fa-star-of-life"/>
                </Label>

                <div className="d-flex justify-content-between">
                    <OTPInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={otpLength}
                        renderSeparator={" "}
                        renderInput={(props) => (
                            <input
                                {...props}
                                disabled={!isOtpRequested || isLoading}
                            />
                        )}
                        containerStyle="flex-row-reverse"
                        inputType="number"
                        inputStyle="login-modal-verify-form-otp-input"
                        shouldAutoFocus={isOtpRequested}
                    />

                    {!isOtpRequested ? (
                        <SubmitButton
                            color="success"
                            className="login-modal-verify-form-timer"
                            onClick={() => requestOtp()}
                            isLoading={isLoadingOtp}
                            actionName="ارسال"
                            type="button"
                        >
                            دریافت کد تایید
                            <RiLockPasswordLine/>
                        </SubmitButton>
                    ) : isLoading ? (
                        <SubmitButton
                            color="success"
                            className="login-modal-verify-form-logging-in"
                            isLoading={isLoading}
                            type="button"
                            isDisabled
                        >
                            <FormattedMessage id="Login"/>
                        </SubmitButton>
                    ) : countDownSeconds > 0 ? (
                        <Button aria-label={""} color="success" className="login-modal-verify-form-timer" disabled>
                            {secondsToHms(countDownSeconds)}
                            <AiOutlineClockCircle/>
                        </Button>
                    ) : (
                        <SubmitButton
                            color="danger"
                            className="login-modal-verify-form-resend"
                            onClick={() => requestOtp()}
                            isLoading={isLoadingOtp}
                            actionName="ارسال"
                            type="button"
                        >
                            دریافت مجدد کد
                            <MdOutlineRefresh/>
                        </SubmitButton>
                    )}
                </div>
            </div>
            {isUserNew &&
                <SubmitButton className="w-100" isLoading={isLoading}>
                    ثبت نام
                </SubmitButton>
            }
        </AvForm>
    );
};

export default VerifyForm;
